import dayjs from 'dayjs'
import { push } from 'firebase/database'

import { contactUsRef } from './database'

export const sendMessage = async (message: string, uid: string) => {
  await push(contactUsRef(uid), { message, createdAt: dayjs().toISOString() })
}
